module.exports = __webpack_public_path__ + "img/build-api-with-swagger.a382d972.png";